import { render, staticRenderFns } from "./Kecamatan.old.vue?vue&type=template&id=1392f090"
import script from "./Kecamatan.old.vue?vue&type=script&lang=js"
export * from "./Kecamatan.old.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports